import React from "react";
const CenteredLayout = ({ children, banner }) => {

  return (
    <div className="relative flex h-screen w-screen items-center justify-center">
      {/* Background Banner */}
      {/* {banner && (
        <img
          src={banner}
          alt="CanTMS"
          className="absolute inset-0 h-full w-full object-cover"
        />
      )} */}

      {/* Dark Overlay for Better Visibility */}
      <div className="absolute inset-0 bg-black bg-opacity-40">
        {banner && (
          <img
            src={banner}
            alt="CanTMS"
            className="absolute inset-0 h-full w-full object-cover"
          />
        )}
      </div>

      {/* Centered Form Container with Transparent Background */}
      <div className="relative z-10 w-full max-w-lg rounded-lg bg-white bg-opacity-80 p-10 ">
        {children}
      </div>
    </div>
  );
};

export default CenteredLayout;
